import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { useScheduleContext } from "@/features/consultations/contexts";
import { useScheduleAppointment } from "@/features/consultations/hooks";
import { INTAKE_FORM_ROUTE } from "@/features/intake-form/router";
import { LogoLoader } from "@/shared/components";
import { Button } from "@/shared/ui";

export const Submit = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    language,
    scheduleDate: { timeSlot },
    appointmentType,
    subscriptionId,
  } = useScheduleContext();

  const { mutation: scheduleAppointment } = useScheduleAppointment();

  const handleContinue = () => {
    if (timeSlot) {
      scheduleAppointment.mutate(
        {
          timeSlot,
          language,
          type: appointmentType,
          subscriptionId,
        },
        {
          onSuccess: () => {
            navigate(INTAKE_FORM_ROUTE.SUCCESS);
          },
          onError: () => {
            void queryClient.invalidateQueries({
              queryKey:
                consultationsQueriesStore.consultations.providers._ctx
                  .availability.queryKey,
            });
          },
        },
      );
    }
  };

  const handleBack = () => {
    return navigate(ROUTES.HOME);
  };

  return (
    <div className="mt-auto flex w-full flex-col-reverse items-center gap-y-4 sm:flex-row sm:justify-between">
      <Button
        onClick={handleBack}
        variant="secondary"
        size="lg"
        className="w-full sm:w-fit"
      >
        {t`Back`}
      </Button>

      <Button
        disabled={!timeSlot || scheduleAppointment.isPending}
        onClick={handleContinue}
        size="lg"
        className="w-full sm:w-fit"
      >
        {t`Confirm Consultation`}
      </Button>

      <LogoLoader show={scheduleAppointment.isPending} fullscreen />
    </div>
  );
};
